<template>
    <div
        class="bonusomat-onboarding__carousel"
        :class="'bonusomat-onboarding__carousel--step-' + onboardingActiveStep"
        ref="sliderContainer"
    >
        <BonusomatOnboardingPage v-for="page in onboardingPages" :key="page.codeName" v-bind="page" />
    </div>
</template>

<script lang="ts" setup>
import { computed, watch } from "vue";
import { KeenSliderInstance } from "keen-slider";
import { useKeenSlider } from "keen-slider/vue.es";
import BonusomatOnboardingPage from "./bonusomat-onboarding-page.vue";

import useBonusomatOnboarding from "../../composables/use-bonusomat-onboarding";

const { onboardingData, onboardingActiveStep, onboardingActiveStepChangedWatch } = useBonusomatOnboarding();

const onboardingPages = computed(() => onboardingData.value?.pages);

const [sliderContainer, slider] = useKeenSlider<HTMLDivElement>({
    selector: ".bonusomat-onboarding-page__device",
    slides: {
        perView: 1,
    },
    slideChanged: (s: KeenSliderInstance) => {
        onboardingActiveStep.value = s.track.details.abs;
    },
    initial: onboardingActiveStep.value,
});

// We can't watch directly the 'onboardingActiveStep' because it can be changed by KeenSlider itself (e.g. when swiping) what causes double move
watch(onboardingActiveStepChangedWatch, () => {
    slider.value.moveToIdx(onboardingActiveStep.value);
});
</script>
